export const SPECIALITIES = {
  specialities: {
    acrobatics: {},
    bikiniFitness: {},
    bodybuilding: {},
    callisthenics: {},
    competitionCoaching: {},
    crossfit: {},
    enduranceSports: {},
    fitness: {},
    functionalTraining: {},
    fustra: {},
    gymnastics: {},
    gymTraining: {},
    handstanding: {},
    highIntensityIntervalTraining: {},
    hydrobics: {},
    hydroRunning: {},
    kettlebell: {},
    martialArts: {},
    meditation: {},
    mentalCoaching: {},
    methodMakia: {},
    methodPutkisto: {},
    mindfulness: {},
    movement: {},
    movementImpaired: {},
    nutritionPrograms: {},
    performanceImprovement: {},
    physiotherapy: {},
    pilates: {},
    postPregnancy: {},
    powerLifting: {},
    pregnancyTimeTraining: {},
    remoteTraining: {},
    running: {},
    seniorCitizens: {},
    strengthAndMuscle: {},
    stressControl: {},
    swimming: {},
    therapeutic: {},
    weightlifting: {},
    weightLoss: {},
    wellness: {},
    yoga: {}
  }
}
